module.exports = "<router-outlet (activate)=\"previousUrlService.navigated.next(true)\"></router-outlet>\n"